import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "overflow-hidden",
  "data-cy": "text-selected-name"
}

import { computed } from "vue";
import { selectionStore, timStore } from "@/hooks";
import {
  PanelCard,
  Typography,
  Icon,
  FlexBox,
  ListItem,
} from "@/components/common";


/**
 * Displays attributes of the selected trace matrix.
 */
const __default__ = {
  name: "TraceMatrixContent",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const traceMatrix = computed(() => timStore.selectedTraceMatrix);
const generatedCount = computed(() => traceMatrix.value?.generatedCount || 0);

const sourceType = computed(() => traceMatrix.value?.sourceType || "");
const sourceIcon = computed(() => timStore.getTypeIcon(sourceType.value));
const sourceColor = computed(() => timStore.getTypeColor(sourceType.value));

const targetType = computed(() => traceMatrix.value?.targetType || "");
const targetIcon = computed(() => timStore.getTypeIcon(targetType.value));
const targetColor = computed(() => timStore.getTypeColor(targetType.value));

return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!

  return (_openBlock(), _createBlock(_unref(PanelCard), { borderless: "" }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(Typography), {
          variant: "caption",
          value: "Parent"
        }),
        _createVNode(_unref(ListItem), {
          clickable: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(selectionStore).selectArtifactLevel(targetType.value)))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Typography), {
              ellipsis: "",
              variant: "subtitle",
              el: "h1",
              class: "q-my-none",
              value: targetType.value
            }, null, 8, ["value"]),
            _createVNode(_component_q_tooltip, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(targetType.value), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(Typography), {
          variant: "caption",
          value: "Child"
        }),
        _createVNode(_unref(ListItem), {
          clickable: "",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(selectionStore).selectArtifactLevel(sourceType.value)))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Typography), {
              ellipsis: "",
              variant: "subtitle",
              el: "h1",
              class: "q-my-none",
              value: sourceType.value
            }, null, 8, ["value"]),
            _createVNode(_component_q_tooltip, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(sourceType.value), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    "title-actions": _withCtx(() => [
      _createVNode(_unref(FlexBox), { column: "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Icon), {
            id: targetIcon.value,
            size: "sm",
            color: targetColor.value
          }, null, 8, ["id", "color"]),
          _createVNode(_unref(Icon), {
            class: "q-my-xs",
            size: "sm",
            color: generatedCount.value > 0 ? 'nodeGenerated' : 'nodeDefault',
            variant: "trace",
            rotate: -90
          }, null, 8, ["color"]),
          _createVNode(_unref(Icon), {
            id: sourceIcon.value,
            size: "sm",
            color: sourceColor.value
          }, null, 8, ["id", "color"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})